import { scoreList, scoreRecalc } from '@/services/ventures/scores.service'

export default {
	namespaced: true,
	state: {
		scoreList: { meta: { pagination: { total: 0 } } },
		scoreStatus: 'pending',
		scoreRecalcStatus: 'init',
	},
	getters: {
		getScoreList: s => s.scoreList,
		getScoreStatus: s => s.scoreStatus,
		getScoreRecalcStatus: s => s.scoreRecalcStatus,
	},
	mutations: {
		SCORE_LIST(state, value) { state.scoreList = value },
		SCORE_STATUS(state, value) { state.scoreStatus = value },
		SCORE_RECALC_STATUS(state, value) { state.scoreRecalcStatus = value },
	},
	actions: {
		async fetchScoreList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('SCORE_STATUS', 'pending')
			commit('SCORE_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await scoreList(params)
				commit('SCORE_STATUS', 'init')
				commit('SCORE_LIST', data)
				return data
			} catch (error) {
				commit('SCORE_STATUS', 'init')
				throw error
			}
		},
		async recalcScore({ commit }, pitchId) {
			commit('SCORE_RECALC_STATUS', 'pending')
			try {
				const { data } = await scoreRecalc(pitchId)
				commit('SCORE_RECALC_STATUS', 'init')
				return data
			} catch (error) {
				commit('SCORE_RECALC_STATUS', 'init')
				throw error
			}
		},
	},
}
